import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthenticatedLayout from './Components/Layout/AuthenticatedLayout';
import FlightRangeAdmin from './views/FlightRangeAdmin';
import FlightRangeModify from './views/FlightRangeModify';
import FlightRange from './views/FlightRange';
import Home from './Components/Home/Home';
import { useAuth } from 'react-oidc-context';
import { useUserRole } from './hooks/useUserRole';
import './App.css';

const App: React.FC = () => {
  const auth = useAuth();
  const { isAdmin, isAuthenticated } = useUserRole();

  if (auth.isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div>Loading...</div>
          <div className="loading-subtitle">Initializing application</div>
        </div>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="error-container">
        <div className="error-content">
          <h2>Authentication Error</h2>
          <p>{auth.error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="retry-button"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/flight-ranges" replace />}
        />

        <Route
          path="/flight-ranges/modify"
          element={
            isAdmin ? (
              <AuthenticatedLayout requireAdmin>
                <FlightRangeModify />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/flight-ranges" replace />
            )
          }
        />

        <Route
          path="/flight-ranges/*"
          element={
            isAdmin ? (
              <AuthenticatedLayout requireAdmin>
                <FlightRangeAdmin />
              </AuthenticatedLayout>
            ) : (
              <AuthenticatedLayout>
                <FlightRange />
              </AuthenticatedLayout>
            )
          }
        />

        <Route
          path="/partners/*"
          element={
            <AuthenticatedLayout>
              <FlightRange />
            </AuthenticatedLayout>
          }
        />

        <Route
          path="*"
          element={<Navigate to="/flight-ranges" replace />}
        />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;